<div cdk-overlay-origin #trigger class="combobox-container" [class.combobox-with-button]="buttonLabel()">
  @if (type() === 'number') {
    <input
      #inputEl
      class="combobox-input"
      type="text"
      inputNumber
      [placeholder]="placeholder()"
      [disabled]="isDisabled()"
      [attr.min]="min()"
      [attr.aria-label]="ariaLabel()"
      role="combobox"
      aria-autocomplete="none"
      [attr.aria-expanded]="isOpen"
      [attr.aria-controls]="isOpen ? listboxId : null"
      [attr.aria-activedescendant]="activeDescendant"
      [value]="displayValue"
      (input)="onInput($event)"
      (blur)="onBlur()"
      (keydown)="onKeyDown($event)" />
  } @else {
    <input
      #inputEl
      class="combobox-input"
      type="text"
      [placeholder]="placeholder()"
      [disabled]="isDisabled()"
      [attr.aria-label]="ariaLabel()"
      role="combobox"
      aria-autocomplete="none"
      [attr.aria-expanded]="isOpen"
      [attr.aria-controls]="isOpen ? listboxId : null"
      [attr.aria-activedescendant]="activeDescendant"
      [value]="displayValue"
      (input)="onInput($event)"
      (blur)="onBlur()"
      (keydown)="onKeyDown($event)" />
  }
  @if (suffix() || suffixHint()) {
    <span class="combobox-suffix-group">
      @if (suffix()) {
        <span class="combobox-suffix">{{ suffix() }}</span>
      }
      @if (suffixHint()) {
        <span class="combobox-suffix-hint">{{ suffixHint() }}</span>
      }
    </span>
  }
  @if (buttonLabel()) {
    <button
      type="button"
      class="combobox-button"
      [disabled]="isDisabled()"
      tabindex="-1"
      [attr.aria-label]="(ariaLabel() ? ariaLabel() + ': ' : '') + buttonLabel()"
      [attr.aria-expanded]="isOpen"
      (mousedown)="$event.preventDefault()"
      (click)="toggleDropdown()">
      {{ buttonLabel() }}
    </button>
  } @else {
    <button
      type="button"
      class="combobox-chevron"
      [disabled]="isDisabled()"
      tabindex="-1"
      [attr.aria-label]="ariaLabel() ? 'Show suggestions for ' + ariaLabel() : 'Show suggestions'"
      [attr.aria-expanded]="isOpen"
      (mousedown)="$event.preventDefault()"
      (click)="toggleDropdown()">
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9" />
      </svg>
    </button>
  }
  <ng-template
    cdk-connected-overlay
    cdkConnectedOverlayLockPosition
    cdkConnectedOverlayHasBackdrop
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayDisableClose]="true"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayMinWidth]="originWidth"
    (detach)="closeDropdown()"
    (backdropClick)="closeDropdown()"
    (overlayOutsideClick)="closeDropdown()">
    <div class="combobox-dropdown" role="listbox" [id]="listboxId" [attr.aria-label]="ariaLabel()">
      @for (option of suggestions(); track option.value; let i = $index) {
        <div
          class="combobox-option"
          role="option"
          [id]="optionId(i)"
          [attr.aria-selected]="i === highlightedIndex"
          [class.highlighted]="i === highlightedIndex"
          [class.keyboard-active]="i === highlightedIndex && keyboardActive"
          (click)="selectOption(option)"
          (mouseenter)="highlightedIndex = i; keyboardActive = false">
          {{ option.label }}
        </div>
      }
    </div>
  </ng-template>
</div>
